import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import IconQuote from "../../images/icon-quote.png";

const quotes = [
    "Easily discover and quickly benefit from the most advanced technologies.",
    "Expert-level insights at your fingertips.",
    "Expedite planning, completion, and fieldwork procedures.",
    "Elevate your expertise and confidence.",
    "AI-powered audits: Save time, increase profitability, and improve quality.",
];

const QuoteSlider = ({ quotes }) => {
    const sliderSettings = {
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: false,
        dots: true,
        adaptiveHeight: true,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    dots: false,
                },
            },
        ]
    };

    return (
        <div className="quote-slider text-center px-4 w-75">
            <img src={IconQuote} alt="quote" className="quote-icon" />
            <Slider {...sliderSettings}>
                {quotes.map((quote, index) => (
                    <div key={index} className="quote-slide">
                        <p className="slide-text">{quote}</p>
                    </div>
                ))}
            </Slider>
        </div>
    );
};

export default QuoteSlider;
